(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("draw-tool", [], factory);
	else if(typeof exports === 'object')
		exports["draw-tool"] = factory();
	else
		root["draw-tool"] = factory();
})(self, function() {
return 